import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotThumbsUp = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                d="M39.16 24.097a2.54 2.54 0 0 0-1.996-3.423 29.01 29.01 0 0 0-3.144-.212c-1.76-.65-4.224-.445-5.97-.378a15.115 15.115 0 0 0-7.723 2.17c-3.945 2.569-6.491 8.108-4.79 12.695 1.783 4.822 7.73 6.046 12.226 5.101a15.87 15.87 0 0 0 11.373-9.915c.832-2.327.817-4.458.023-6.038Z"
                opacity={0.8}
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M11.665 36.666h-5a3.333 3.333 0 0 1-3.333-3.333V21.666a3.333 3.333 0 0 1 3.333-3.333h5M23.332 15V8.333a5 5 0 0 0-5-5l-6.667 15v18.333h18.8a3.333 3.333 0 0 0 3.334-2.833l2.3-15A3.334 3.334 0 0 0 32.765 15h-9.433Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotThumbsUp.displayName = "SpotThumbsUp";
